import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts'
import { SOCIAL_LOGIN } from 'graphql/service'
import { useAuth } from 'customHooks/useAuth'

const debug = false

const AuthCallbackFacebook: FC = () => {

  const { loginWithToken } = useAuth()
  const location = useLocation()
  const { showGlobalError, showGlobalMessage } = useGlobalAlerts()

  const [socialLogin] = useMutation(SOCIAL_LOGIN)

  // Dependency list updated during ESLint cleanup.
  // This provider's OAuth flow has not been runtime-tested.
  // Revalidate during the planned OAuth integration work.
  useEffect(() => {
    const params = new URLSearchParams(location.search)

    const code = params.get('code')
    const returnedState = params.get('state')
    const oauthError = params.get('error') || params.get('error_message') 

    if (debug) {
      console.log('FB code:', code)
      console.log('FB returnedState:', returnedState)
      console.log('FB oauthError:', oauthError)
    }

    if (oauthError) {
      showGlobalError(oauthError)
      return
    }

    if (!code) {
      showGlobalError('Missing authorization code.')
      return
    }

    const savedState = sessionStorage.getItem('oauth_state')
    if (!returnedState || !savedState || returnedState !== savedState) {
      showGlobalError('Invalid OAuth state. Please try again.')
      return
    }

    const codeVerifier = sessionStorage.getItem('pkce_verifier_FACEBOOK')
    if (!codeVerifier) {
      showGlobalError('Missing PKCE code verifier. Please try again.')
      return
    }

    const redirectUri = `${window.location.origin}/auth/callback/facebook`

    if (debug) {
      console.log('FB codeVerifier:', codeVerifier)
      console.log('FB redirectUri:', redirectUri)
    }

    socialLogin({
      variables: {
        input: {
          provider: 'META', 
          authorizationCode: code,
          codeVerifier,
          redirectUri,
        },
      },
    })
      .then((res) => {
        const token = res?.data?.socialLogin?.accessToken
        if (!token) {
          showGlobalError('Social login failed: no access token returned.')
          return
        }

        loginWithToken(token, '/account/dashboard')
        showGlobalMessage('Signed in successfully.')
      })
      .catch((e) => {
        showGlobalError(e?.message || 'Social login failed.')
      })
  }, [location.search, loginWithToken, showGlobalError, showGlobalMessage, socialLogin])

  return <div style={{ padding: 100 }}>Completing Facebook sign-in...</div>
}

export default AuthCallbackFacebook
